import React, {useEffect, useRef, useState} from 'react';
import {useDispatch} from "react-redux";
import './Quiz.sass';
import EnhancedPopUp from "../../ui/PopUp/EnhancedPopUp";
import apiJSON from "../../../api/apiJSON";
import renderHTML from "react-render-html"
import gsap from 'gsap';
import _ from 'lodash'
import Button from "../../ui/Button/Button";
import {gotoMenu, setAudio} from "../../../store/actions/course.action";
import StandardButton from "../../ui/Button/StandardButton";

const Quiz = ({data, completed, next}) => {

    const [scenarioIndex, setScenarioIndex] = useState(0);
    const [questionIndex, setQuestionIndex] = useState(0);
    const [choiceSet, setChoiceSet] = useState(null);
    const [feedback, setFeedback] = useState(null);
    const [selections, setSelections] = useState([]);
    const [selectedChoice, setSelectedChoice] = useState(null);
    const [abort, setAbort] = useState(false)

    const jsonData = apiJSON.get(data);
    const {scenarios,testMode,remedialMode} = jsonData;
    const scenario = scenarios[scenarioIndex];

    const dispatch = useDispatch();

    useEffect(() => {
        console.log("Quiz scenarioIndex update()");
        gsap.from('.scenario', {x: -1200, ease: "expo.out"});
        if (scenario.audio) {
            playAudio();
        }
        setQuestionIndex(0);
    }, [scenarioIndex]);


    useEffect(() => {
        console.log("Quiz questionIndex update()");
        setChoiceSet(scenario.choiceSets[questionIndex]);
        gsap.set('.questionPanel', {visibility: "hidden"});
        setTimeout(function () {
            gsap.set('.questionPanel', {visibility: "visible"})
            gsap.from('.questionPanel', {x: 1200, duration: 1, ease: "expo"});
        }, .5);
    }, [questionIndex, scenarioIndex])

    useEffect(() => {
        console.log("Quiz choiceSet update()");
        resetSelections();
    }, [choiceSet]);

    useEffect(() => {
        console.log("Quiz selections updated(", selections, ")");
    }, [selections]);


    const resetSelections = () => {
        if (!choiceSet) return;
        let s = [];
        choiceSet.choices.map((choice, index) => {
            s[index] = 0
        });
        setSelections(s)
    }

    const playAudio = () => {
        if (scenario.audio) {
            dispatch(setAudio(scenario.audio))
        }
    }

    const isSelected = (index) => {
        return (selections[index] === 1)
    }

    const handleChoice = (index) => {
        console.log("Quiz handleChoice(", index, ")");
        var c = scenario.choiceSets[questionIndex].choices[index];
        let s = selections.slice();
        if (choiceSet.type === "select") {
            s[index] = (s[index] === 0) ? 1 : 0;
            setSelections(s);
        } else {
            s.map((c, i) => {
                s[i] = (i === index) ? 1 : 0;
            })
            setSelections(s);
        }
        if(choiceSet.type === "radio"){
            setSelectedChoice(c)
        }
        else if(choiceSet.type !== "select"){
            if (c.feedback) {
                setFeedback(c.feedback);
            } else {
                handleContinue();
            }
            if (scenario.testMode && !c.correct) {
                setAbort(true);
            }
        }
    };

    const evaluateSelection = () => {
        console.log("Quiz evaluateSelection()");
        let success = true;
        for (var i = 0; i < choiceSet.choices.length; i++) {
            var c = choiceSet.choices[i];
            if (selections[i] === 1 && !c.correct) {
                success = false;
                break;
            } else if (selections[i] === 0 && c.correct) {
                success = false;
                break;
            }
        }
        if (testMode && !success) {
            setAbort(true);
        }
        return success;
    }

    const advance = () => {
        if (abort) {
            dispatch(gotoMenu());
            return;
        }
        if (questionIndex + 1 >= scenario.choiceSets.length) {
            if (scenarioIndex + 1 < jsonData.scenarios.length) {
                setScenarioIndex(scenarioIndex + 1);
            } else {
                finished();
            }
        } else {
            setQuestionIndex(questionIndex + 1)
        }
    }

    const handleContinue = () => {
        setFeedback(null);
        if (remedialMode) {
            let correct = evaluateSelection();
            if (correct) {
                advance();
            } else {
                resetSelections();
            }
        }
        else{
            advance();
        }
    };

    const handleSubmit = () => {
        console.log("Quiz handleSubmit()");
        let fb
        if(choiceSet.type=="select"){
            fb = evaluateSelection() ? choiceSet.feedback : (choiceSet.altFeedback ? choiceSet.altFeedback : choiceSet.feedback)
        }
        else if(choiceSet.type=="radio"){
            fb = selectedChoice.feedback;
            if(testMode && !selectedChoice.correct){
                setAbort(true)
            }
        }
        if(fb){
            setFeedback(fb);
        }
        else{
            handleContinue();
        }
    }

    const isDisabled = () =>{
        console.log("Quiz isDisabled()");
        console.log("   choiceSet.type: ", choiceSet.type);

        if(choiceSet.type==="select"){
            console.log("   selections: ", selections);
           return (selections.indexOf(1)===-1);
        }
        else if(choiceSet.type==="radio"){
            return  (selectedChoice===null);
        }
        else
        {
            return true;
        }
    }

    const finished = () => {
        completed();
        if (next) next();
    };

    return (
        <div className={"quiz page-layout-basic"}
             style={(scenario.bg ?
                 {"background-image": "url(" + scenario.bg + ")"}
                 : {})}>
            {feedback && (
                <EnhancedPopUp data={feedback}
                               onHide={handleContinue}/>
            )}
            {(scenario && scenario.caption) &&
            <div className={scenario.caption.className ? scenario.caption.className : "caption"}
                 style={(scenario.caption.style ? scenario.caption.style : {})}>
                {scenario.caption.body}
            </div>}
            {(scenario && scenario.image) &&
            <div className="image-holder"
                 style={(scenario.image.style ? scenario.image.style : {})}><img src={scenario.image.url}/></div>

            }
            {(scenario && (scenario.title || scenario.body)) &&
            <div className="scenario"
                 style={scenario.style ? scenario.style : {}}>
                {scenario.title &&
                <div className="scenario-title">
                    {scenario.title}
                </div>
                }
                {(scenario.title || scenario.body) &&
                <div className="divider"/>}
                {scenario.body &&
                <div className="scenario-body">
                    {renderHTML(scenario.body)}
                </div>
                }
            </div>
            }
            {choiceSet ? (
                <div className="questionPanel"
                     style={(choiceSet.style ? choiceSet.style : {})}>
                    {choiceSet.title &&
                    <div className="panel-title">
                        {choiceSet.title}
                    </div>
                    }
                    {(choiceSet.title || choiceSet.body) &&
                    <div className="divider"/>}
                    {choiceSet.body &&
                    <div className="panel-body">
                        {renderHTML(choiceSet.body)}
                    </div>
                    }
                    <div className={"buttonPanel" + (choiceSet.type === "binary" ? " row" : "")}>
                        {choiceSet.choices.map((choice, index) => (
                            <Button data={choice.label}
                                    key={"choice" + index}
                                    className={"choice " + (isSelected(index) ? " selected" : "")}
                                    style={choiceSet.type === "binary" ? {"flex": 1} : {}}
                                    selected={isSelected(index)}
                                    type={choiceSet.type ? choiceSet.type : null}
                                    callback={() => {
                                        handleChoice(index)
                                    }}>

                            </Button>
                        ))}
                    </div>
                    {(choiceSet.type === "select" || choiceSet.type === "radio") &&
                    <StandardButton data={"Submit"}
                            disabled={isDisabled()}
                            style={{"margin": "auto", "marginTop": "5px"}}
                            callback={handleSubmit}/>}
                </div>
            ) : null
            }
        </div>

    )
}

export default Quiz;